import { GET_ALL_TAGS, GET_SPECIFIC_TAG, GET_TAG_USE } from './mutation-types'

export default {
  [GET_ALL_TAGS]: (state, tags) => {
    state.tags = tags
  },
  [GET_SPECIFIC_TAG]: (state, tag) => {
    state.tag = tag
  },
  [GET_TAG_USE]: (state, tagUse) => {
    state.tagUse = tagUse
  }
}
